'use strict';
/*!
 * Here comes description.
 *
 * @package tokai-univ
 * @deps masonry
 */

const masonryElmExist = document.getElementsByClassName( 'js-masonry' ).length;

// Register event listener.
document.addEventListener( 'readystatechange', function () {
	if ( masonryElmExist ) {
		const masonryElementsArray = document.querySelectorAll( '.js-masonry' );
		const masonryArray = Array.prototype.slice.call( masonryElementsArray );
		masonryArray.forEach( function ( masonryElement ) {
			new Masonry( masonryElement, {
				itemSelector: '.js-masonry-item',
				horizontalOrder: true,
				gutter: 20,
				percentPosition: true,
			} );
		} );
	}
} );

( function () {
	'use strict';
	const masonries = document.getElementsByClassName( 'js-masonry' );
	function applyMasonry() {
		if ( masonries.length ) {
			const t = document.querySelectorAll( '.js-masonry' );
			Array.prototype.slice.call( t ).forEach( function ( e ) {
				new Masonry( e, {
					itemSelector: '.js-masonry-item',
					isFitWidth: true,
					horizontalOrder: ! 0,
					gutter: 20,
					percentPosition: ! 0,
				} );
			} );
		}
	}
	document.addEventListener( 'readystatechange', applyMasonry );
	document.addEventListener( 'wovnLangChanged', applyMasonry );
	document.addEventListener( 'wovnWaitAuditCompleted', applyMasonry );
} )();
